import { arabicNumbersToEnglish,number_reg_arabic } from "./FormikHandleChange";

export default function Input({
  label,
  formik,
  onChange,
  width,
  minWidth,
  value,
  setValue = false,
  name,
  disabled = false,
  height,
  UserIcon,
  type = "text",
  lableClass,
  minValue = "0",
  placeholder,
  bankPattern = false,
  classnam = null,
  className = null,
  onKeyPress,
  maxLength,
  minLength,
  cursor,
  isW100 = false,
  addNewclassForWidth
  
}) {
  

 

  return (
    <div
      className={`d-flex flex-column ${addNewclassForWidth ? addNewclassForWidth : isW100 ? 'w-100PMV' : 'w-100MV'} ${className}`}
      style={{ width: width, minWidth: minWidth }}
    >
      <div className={`label f-9 ${lableClass}`}>
        {label}
        {UserIcon}
      </div>
      <input
        className={`${classnam} ${addNewclassForWidth ? addNewclassForWidth : ''}`}
        // type={ type}
        name={name}
        value={value}
        onKeyPress={onKeyPress}

        // onChange={
        //   setValue
        //     ? (e) =>
        //         setValue((prev) =>
        //           type == "number"
        //             ? number_reg.test(e.target.value)
        //               ? e.target.value
        //               : ""
        //             : e.target.value
        //         )
        //     : onChange
        // }

        onChange={
          setValue
            ? (e) => {
                // Replace Arabic numbers with English before setting value
                // const updatedValue = replaceArabicNumbers(e.target.value);
                setValue((prev) =>{
                  if(type === "number"){
                    console.log('number_reg_arabic.test(e.target.value)',number_reg_arabic.test(e.target.value));

                    if(number_reg_arabic.test(e.target.value)==true){
                       let text=arabicNumbersToEnglish(e.target.value);
                      return text;
                    } 
                    else if(e.target.value=='') {
                        return e.target.value;
                    }
                    else{
                      return prev;
                    }
                  }
                  else return e.target.value 
                }
                  
                    
                );
              }
            : (e) => {
                // If no setValue, process onChange as well
                 const updatedValue = e.target.value;
              if(onChange)  onChange(e, updatedValue);
              else return e.target.value
                
              }
        }
        
        placeholder={`${placeholder ? placeholder : label}`}
        readOnly={disabled}
        style={{ height: height, fontFamily: "Cairo", cursor:cursor }}
        min={minValue}
        maxLength={maxLength}
        minLength={minLength}
      />
    </div>
  );
}
